import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import { Loader2, MailCheck } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { AuthShell } from "./Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell>
      <div className="rounded-2xl border border-slate-200 bg-white p-8">
        {sent ? (
          <div className="text-center">
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-emerald-50 text-emerald-600">
              <MailCheck className="h-6 w-6" />
            </div>
            <h1 className="mt-4 font-heading text-xl font-800 text-slate-900">Controlla la tua email</h1>
            <p className="mt-2 text-sm text-slate-500">
              Se l'indirizzo è registrato, riceverai un'email con le istruzioni per reimpostare la password.
            </p>
            <Button asChild className="mt-6 w-full rounded-full bg-blue-700 hover:bg-blue-800">
              <Link to="/login" data-testid="back-to-login-btn">Torna all'accesso</Link>
            </Button>
          </div>
        ) : (
          <>
            <h1 className="font-heading text-2xl font-800 text-slate-900">Recupera password</h1>
            <p className="mt-1 text-sm text-slate-500">Ti invieremo un link per reimpostare la password.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5" data-testid="forgot-email-input" />
              </div>
              {error && <p className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-600">{error}</p>}
              <Button type="submit" disabled={loading} className="w-full rounded-full bg-blue-700 hover:bg-blue-800" data-testid="forgot-submit-btn">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Invia link di recupero"}
              </Button>
            </form>
            <p className="mt-6 text-center text-sm text-slate-500">
              <Link to="/login" className="font-600 text-blue-700 hover:underline">Torna all'accesso</Link>
            </p>
          </>
        )}
      </div>
    </AuthShell>
  );
}
